import { SaveOutlined, UploadOutlined } from "@ant-design/icons";
import {
  Avatar,
  Button,
  Image,
  Input,
  Radio,
  Upload,
  UploadFile,
  message,
  Modal,
} from "antd";
import Card from "antd/lib/card/Card";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import axiosInstance from "../../axios/axios-instance";
import { pathAPI } from "../../utils/pathApi";
import "./HelpSupportDetail.scss";
import api from "../../hooks/api";
import { RcFile } from "antd/lib/upload";
import { Box } from "@mui/material";
import { useBreadcrumbLabel } from "../../components/breadcrumb/BreadcrumbContext";

const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
const HelpSupportDetail = () => {
  const { i18n, t } = useTranslation();
  const { id } = useParams<{ id: any }>();
  const [title, setTitle] = useState("");
  useBreadcrumbLabel(title);
  const [titleStatus, setTitleStatus] = useState("");
  const [status, setStatus] = useState("");
  const [description, setDescription] = useState("");
  const [messageReply, setMessageReply] = useState([]);
  const [checkedStatus, setCheckedStatus] = useState("waiting");
  const [reply, setReply] = useState("");
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const getDetailSupportTicket = async () => {
    await axiosInstance
      .get(`${pathAPI.supportTicket}/${id}`)
      .then((data: any) => {
        setTitle(data.data.title);
        setStatus(data.data.status);
        setDescription(data.data.description);
        setMessageReply(data.data.list_message);
        changeStyleStatus(data.data.status);
      })
      .catch((e) => console.log("======== ERROR: ", e));
  };
  const saveSupportTicket = async () => {
    if (reply.length == 0) {
      message.error(`${t("help_support_detail.mess_err")}`);
      return;
    }
    setLoading(true);
    const formData = new FormData();
    if (fileList.length > 0) {
      fileList.forEach((file: any) => {
        formData.append("files", file.originFileObj);
      });
    }
    formData.append("message", reply);
    formData.append("ticketId", id);
    return api
      .POST(pathAPI.supportTicket, formData, {}, true)
      .then(() => {
        message.success(`${t("help_support_detail.mess_success")}`);
        setLoading(false);
        clearFormData();
      })
      .catch(() => {
        console.log("===== POST ERROR");
        setLoading(false);
      });
  };

  const clearFormData = () => {
    setFileList([]);
    setReply("");
  };

  const changeStyleStatus = (status: string) => {
    if (status == "WAITING") {
      setTitleStatus("title-status title-status-waiting");
      setCheckedStatus("waiting");
    } else if (status == "SUPPORTING") {
      setTitleStatus("title-status title-status-supporting");
      setCheckedStatus("supporting");
    } else {
      setTitleStatus("title-status title-status-closed");
      setCheckedStatus("closed");
    }
  };
  var isUpload = true;
  const uploadFile = (file: any) => {
    var res = fileList.filter((item) => item.uid === file.file.uid);
    if (res.length == 0 && isUpload) {
      setFileList([...fileList, file.file]);
    }
  };

  const handleRadioChange = async (e: any) => {
    setCheckedStatus(e.target.value);
    await axiosInstance.patch(
      `${pathAPI.supportTicket}/${id}/${e.target.value}`
    );
    changeStyleStatus(e.target.value.toUpperCase());
    message.success(`${t("help_support_detail.mess_success")}`);
  };

  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url!.substring(file.url!.lastIndexOf("/") + 1)
    );
  };

  const handleOnRemoveUploaded = (file: any) => {
    const fileArr = fileList.filter((item) => item.uid != file.uid);
    setFileList(fileArr);
    isUpload = false;
  };

  const dummyRequest = () => {
    setTimeout(() => {}, 0);
  };

  useEffect(() => {
    getDetailSupportTicket();
  }, [loading]);
  return (
    <div className="help-support-detail">
      <Box fontWeight={"bold"} fontSize="24px" mb={2}>
        Help-support Detail
      </Box>
      <div className="title">
        <div className="title-head">
          <div className="title-text">{t("help_support_detail.title")}</div>
        </div>
        <Card>
          <div>{title}</div>
        </Card>
      </div>
      <div className="item status">
        <div className="title-head">
          <div className="status-text">{t("help_support_detail.status")}</div>
          <div className={titleStatus}>{status}</div>
        </div>
        <Radio.Group onChange={handleRadioChange} value={checkedStatus}>
          <Radio value={"waiting"}>{t("common.filter_navbar.waiting")}</Radio>
          <Radio value={"supporting"}>
            {t("common.filter_navbar.supporting")}
          </Radio>
          <Radio value={"closed"}>{t("common.filter_navbar.closed")}</Radio>
        </Radio.Group>
      </div>
      <div className="item description">
        <div className="title-text">{t("help_support_detail.description")}</div>
        <Card>
          <div>{description}</div>
        </Card>
      </div>
      <div className="item editor">
        <div className="title-text">{t("help_support_detail.reply")}</div>
        <Input.TextArea
          rows={5}
          onChange={(text: any) => setReply(text.target.value)}
          value={reply}
        />
        <div className="reply-button">
          <Upload
            accept="image/png, image/jpeg"
            onPreview={handlePreview}
            listType="picture"
            defaultFileList={[]}
            onChange={(file: any) => uploadFile(file)}
            maxCount={3}
            multiple
            onRemove={(file) => handleOnRemoveUploaded(file)}
            customRequest={() => dummyRequest}
          >
            <Button icon={<UploadOutlined />}>{t("btn.upload")}</Button>
          </Upload>
          <Modal
            open={previewOpen}
            title={previewTitle}
            footer={null}
            onCancel={handleCancel}
          >
            <img alt="example" style={{ width: "100%" }} src={previewImage} />
          </Modal>
          <Button
            icon={<SaveOutlined />}
            loading={loading}
            type={"primary"}
            style={{ background: "#ba2156" }}
            onClick={saveSupportTicket}
          >
            {t("btn.save")}
          </Button>
        </div>
      </div>
      <div className="item comments">
        <>
          {messageReply.map((item: any) => {
            var messageUserRole = "";
            if (item.message_user_role == "ADMIN") {
              messageUserRole = "message-user-role message-user-role-admin";
            } else {
              messageUserRole =
                "message-user-role message-user-role-user-salon";
            }
            return (
              <Card>
                <div className="message">
                  <div className="avatar">
                    <Avatar
                      src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                      alt="Han Solo"
                    />
                  </div>
                  <div className="message_content">
                    <div className="message-title">
                      <div className={messageUserRole}>
                        {item.message_user_role}
                      </div>
                      <div className="message-time">
                        {moment(item.created_date).format(
                          "YYYY/DD/MM HH:mm:ss"
                        )}
                      </div>
                    </div>
                    <div className="message-content">{item.message}</div>
                    <div className="message-image">
                      <>
                        {item.image_urls.map((element: string) => {
                          return (
                            <Image
                              style={{ marginRight: "5px" }}
                              width={200}
                              src={element}
                            />
                          );
                        })}
                      </>
                    </div>
                  </div>
                </div>
              </Card>
            );
          })}
        </>
      </div>
    </div>
  );
};
export default HelpSupportDetail;
